/**
 * Float nav
 * 
 * @Author: Focci
 * @Date: 2023-08-12 14:09:58
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-12 14:09:58
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import BackTop from './BackTop'
import PopupMenu, { FloatingMenuPanel } from './PopupMenu'

export { BackTop, PopupMenu, FloatingMenuPanel }

export default function FloatNav({
  className = 'fixed right-4 bottom-16',
  children
}) {
  return (
    <div className={clsx(['z-[100] flex flex-col gap-2', className])}>
      {children}
    </div>
  )
}

FloatNav.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}
